import React from 'react'
import PickupClientSection from '../../PickupClientSection'
import { FlyerCodesGiveOutWidget } from '../../FlyerCodesGiveOutWidget'
import MissionsTable from '../../MissionsTable'
import { usePickupContext } from '../../context/PickupContext'
import PowerBanksSection from '../../PowerBanksSection'

const ClientView = ({
  availableMerchandise = [],
  givenOutMerchandise = [],
  availablePowerBanks = [],
  givenOutPowerBanks = [],
  availableCodes = [],
  givenOutCodes = [],
  ambassadors = [],
  missions = [],
  clientLogo = '',
  clientName = '',
  clientId,
  filterByMerch,
  updateLocalInventoryState,
  updateLocalPowerBankState,
}) => {
  const {
    pickupContextState: {
      assignInventoryToUser,
      returnInventoryFromUser,
      selectedBrandAmbassadors,
      selectedCodes,
      campaigns,
      cityId,
    },
  } = usePickupContext()

  const filteredAvailableMerchandise = (() => {
    if (!filterByMerch) return availableMerchandise
    var filterHash = {}
    filterByMerch.forEach(c => (filterHash[c] = true))
    return availableMerchandise.filter(c =>
      filterByMerch.includes(`${c.title} ${c.code}`),
    )
  })()

  const filteredGivenOutMerchandise = (() => {
    if (!filterByMerch) return givenOutMerchandise
    var filterHash = {}
    filterByMerch.forEach(c => (filterHash[c] = true))
    return givenOutMerchandise.filter(c =>
      filterByMerch.includes(`${c.title} ${c.code}`),
    )
  })()

  const filteredAvailableCodes = (() => {
    if (selectedCodes === null || selectedCodes.length === 0)
      return availableCodes
    var filterHash = {}
    selectedCodes.forEach(c => (filterHash[c] = true))
    return availableCodes.filter(c => filterHash[c.code])
  })()

  const filteredGivenOutCodes = (() => {
    if (selectedCodes === null || selectedCodes.length === 0)
      return givenOutCodes
    var filterHash = {}
    selectedCodes.forEach(c => (filterHash[c] = true))
    return givenOutCodes.filter(c => filterHash[c.code])
  })()

  const findCampaignId = inventoryObj => {
    const campaignId = +campaigns.filter(
      ({ client }) => client.id === inventoryObj.clientId,
    )[0].id
    return campaignId
  }

  return (
    <div>
      <PickupClientSection logo={clientLogo} name={clientName}>
        <h4 className="section-title">Merchandise</h4>
        {filteredAvailableMerchandise.length ||
        filteredGivenOutMerchandise.length ? (
          <FlyerCodesGiveOutWidget
            inventoryType="Merchandise"
            selectedBrandAmbassadors={selectedBrandAmbassadors}
            updateLocalInventoryState={updateLocalInventoryState}
            availableCodes={filteredAvailableMerchandise}
            givenOutCodes={filteredGivenOutMerchandise}
            onGiveInventoryToBA={function(ambassadorId, inventoryObj) {
              return assignInventoryToUser(
                { ...inventoryObj, clientId },
                1,
                ambassadorId,
                findCampaignId(inventoryObj),
              )
            }}
            onReturnCode={function(ambassadorId, inventoryObj) {
              return returnInventoryFromUser(
                { ...inventoryObj, clientId },
                1,
                ambassadorId,
                findCampaignId(inventoryObj),
              )
            }}
            ambassadors={ambassadors}
          />
        ) : (
          'No merchandise yet'
        )}

        {(availablePowerBanks.length > 0 || givenOutPowerBanks.length > 0) && (
          <PowerBanksSection
            cityId={cityId}
            availableUnits={availablePowerBanks}
            givenOutUnits={givenOutPowerBanks}
            ambassadors={ambassadors}
            selectedBrandAmbassadors={selectedBrandAmbassadors}
            updateLocalPowerBankState={updateLocalPowerBankState}
          />
        )}

        <h4 className="section-title">Missions</h4>
        {missions && missions.length ? (
          <MissionsTable missions={missions} />
        ) : (
          'No missions yet'
        )}
        <h4 className="section-title">Flyers</h4>
        {filteredAvailableCodes.length || filteredGivenOutCodes.length ? (
          <FlyerCodesGiveOutWidget
            inventoryType="Flyers"
            selectedBrandAmbassadors={selectedBrandAmbassadors}
            updateLocalInventoryState={updateLocalInventoryState}
            totalAvailableCodes={availableCodes.length}
            availableCodes={filteredAvailableCodes}
            givenOutCodes={filteredGivenOutCodes}
            onGiveInventoryToBA={function(ambassadorId, inventoryObj) {
              return assignInventoryToUser(
                inventoryObj,
                inventoryObj.quantity,
                ambassadorId,
                findCampaignId(inventoryObj),
              )
            }}
            onReturnCode={function(ambassadorId, inventoryObj) {
              return returnInventoryFromUser(
                inventoryObj,
                inventoryObj.quantity,
                ambassadorId,
                findCampaignId(inventoryObj),
              )
            }}
            ambassadors={ambassadors}
          />
        ) : (
          'No flyers yet'
        )}
      </PickupClientSection>
    </div>
  )
}

export default ClientView
